import { createFileRoute } from '@tanstack/react-router'
import ModuleCtasPreviewPage from '@/pages/dashboard/module-ctas-preview-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sistema/preview-ctas',
)({
  component: function PreviewCtasRoute() {
    const { dashboardId } = Route.useParams()

    return (
      <ProtectedRoute capability={CAPABILITIES.MANAGE_DASHBOARD_CONFIG}>
        <ModuleCtasPreviewPage dashboardId={dashboardId} />
      </ProtectedRoute>
    )
  },
})
